import { Controller } from '@hotwired/stimulus';

// One date field bounds another: the day being held is the last day its deadline may fall on
// (#243), so picking 20 August up top puts a `max` of 20 August on "trzymam do" and the
// picker simply will not offer later days.
//
//   <div data-controller="date-range" data-action="change->date-range#update">
//     <input type="date" data-date-range-target="limit">    <- the day being held
//     <input type="date" data-date-range-target="bounded">  <- must not fall after it
//
// Progressive enhancement: the server renders the same `max` from whatever date it already
// knows, and Availability refuses a deadline past the held day whatever arrives. This only
// moves the answer to the moment of typing, which is where it is useful.
export default class extends Controller {
  static targets = ['limit', 'bounded'];

  connect() {
    this.update();
  }

  update() {
    if (!this.hasLimitTarget || !this.hasBoundedTarget) return;

    // No day picked yet means no ceiling - not a ceiling of "" , which some browsers read as
    // "nothing is allowed".
    const limit = this.limitTarget.value;
    if (limit) this.boundedTarget.max = limit;
    else this.boundedTarget.removeAttribute('max');
  }
}
